import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlus,
  faMicrophoneAlt,
  faMicrophone,
  faTrashAlt,
  faPlay,
  faStop,
  faPause,
  faDownload,
  faUpload,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add([
  faPlus,
  faMicrophoneAlt,
  faMicrophone,
  faTrashAlt,
  faPlay,
  faStop,
  faPause,
  faDownload,
  faUpload,
]);

Vue.component('font-awesome-icon', FontAwesomeIcon);
